<ul class="navbar-nav mr-auto">
  <li class="nav-item">
    <app-user-nav-search></app-user-nav-search>
  </li>
</ul>